import {
  ApiSignupVerifyResponseSchema,
  type TApiSignupVerifyResponse,
  type TApiSignupVerifyParams,
  TApiSignupVerifyResponseCookie,
  ApiSignupVerifyResponseCookieSchema,
  TApiSignupCreateParams,
  TApiSignupCreateResponse,
  ApiSignupCreateResponseSchema,
} from "@/api/launcherApp/signup/schema"
import { buildCookieString, buildJSessionIDCookie, parseSetCookieHeader } from "@/api/launcherApp/signup/utils"
import { makeURL } from "@nauverse/make-url"
import consola from "consola"

const ENDPOINT_BASE_URL = "/launcher-app/signup"

type TVerifyProps = TApiSignupVerifyParams

export async function verify(params: TVerifyProps): Promise<TApiSignupVerifyResponse> {
  const baseURL = process.env.NEXT_PUBLIC_BASE_SIGNUP_URL

  if (!baseURL) {
    throw new Error("NEXT_PUBLIC_BASE_SIGNUP_URL is not set")
  }

  const queryURL = makeURL(baseURL, ENDPOINT_BASE_URL, "verify")

  try {
    const receivedJson = await fetch(queryURL, {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
      credentials: "include",
    })

    // Get also the cookie
    const cookies = receivedJson.headers.get("Set-Cookie")

    // Parse the cookies with all the cookie parameters
    const parsedCookies = parseSetCookieHeader(cookies ?? "")
    // consola.info("Cookies", parsedCookies)

    const json = (await receivedJson.json()) as Record<string, unknown>
    const parsedJson = ApiSignupVerifyResponseSchema.parse({
      ...json,
      cookies: [...parsedCookies, buildJSessionIDCookie()],
    })

    return parsedJson
  } catch (err) {
    consola.error("Error with the signup verify query", err)
    consola.info("Query URL", queryURL)
    consola.info("Params", JSON.stringify(params, null, 2))

    throw new Error("Error verifying signup")
  }
}

export async function create(params: TApiSignupCreateParams): Promise<TApiSignupCreateResponse> {
  const baseURL = process.env.NEXT_PUBLIC_BASE_SIGNUP_URL

  if (!baseURL) {
    throw new Error("NEXT_PUBLIC_BASE_SIGNUP_URL is not set")
  }

  const queryURL = makeURL(baseURL, ENDPOINT_BASE_URL, "create")

  try {
    const cookiesString = buildCookieString(params)
    console.log("Cookies", cookiesString)
    const receivedJson = await fetch(queryURL, {
      method: "POST",
      body: JSON.stringify({}),
      headers: {
        "Content-Type": "application/json",
        // Send the cookies by creating a new cookie header
        // Cookie: cookiesString,
      },
      credentials: "include",
      signal: AbortSignal.timeout(60 * 1_000),
      //   credentials: "include",
      cache: "no-store",
    })

    const json = (await receivedJson.json()) as Record<string, unknown>
    const parsedJson = ApiSignupCreateResponseSchema.parse(json)

    return parsedJson
  } catch (err) {
    consola.error("Error with the signup create query", err)
    consola.info("Query URL", queryURL)
    consola.info("Params", JSON.stringify(params, null, 2))

    throw new Error("Error creating signup")
  }
}
